import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GridService } from '../shared/grid/grid.service';
import { LocationModel } from '../models/location.model';
import { GroupLookup } from '../models/lookup.model';
import { Observable, catchError, map, of } from 'rxjs';
import { ToastService } from './toast.service';

@Injectable({
    providedIn: 'root'
})
export class LocationService extends GridService<LocationModel> {

    constructor(http: HttpClient, private toastService: ToastService) {
        super('Location', http);
    }

    getGroupLookups(): Observable<GroupLookup[]> {
        return this.http.get<GroupLookup[]>(this.getApiUrl(`${this.controllerName}/GetGroupLookups`))
            .pipe(
                map((groups) =>
                    groups
                        .map((group) => ({
                            ...group,
                            items: (group.items || []).sort((a, b) => a.name.localeCompare(b.name)),
                        }))
                        .sort((a, b) => a.groupName.localeCompare(b.groupName))
                ),
                catchError(error => {
              this.toastService.displayErrorMessage('Error loading locations', true);
              return of([]);
            })
          );
      }
}